import './css/site.css';
import './css/font-awesome-animation.min.css';

import oidc from 'oidc-client';
import 'bootstrap';
import $ from 'jquery';
import jQuery from 'jquery';
import Vue from 'vue';
import VueRouter from 'vue-router';
import moment, { relativeTimeRounding } from 'moment';
import toastr from 'toastr'
import Dal from './scripts/dataaccess'
import { CarehomeDto } from './dto/CarehomeDto'
import FmdDal from './scripts/FmdDal';
import BaseDal from './scripts/BaseDal';
import FmdBaseDal from './scripts/FmdBaseDal';
import shortkey from './scripts/shortkeyV2';
import UiSession from './Tracking/LogManager'


class AppUserManager {
    private UserManager: oidc.UserManager;

    private _scope: string = "openid profile email api1";
    private _responseType: string = "id_token token";
    private _accessToken: string;

    public async AccessToken(): Promise<string> {
        var user = await this.UserManager.getUser()
        return user.access_token;
    }

    public ConfigureOidc(authority: string) {
        var config = {
            authority: authority,
            //client_id: "js_oidc",
            client_id: "pharmacy_portal_implicit",
            //redirect_uri: window.location.origin + "/callback.html",
            redirect_uri: window.location.origin + "/callback.html",
            post_logout_redirect_uri: window.location.origin + "/",

            // if we choose to use popup window instead for logins
            popup_redirect_uri: window.location.origin + "/popup.html",
            popupWindowFeatures: "menubar=yes,location=yes,toolbar=yes,width=1200,height=800,left=100,top=100;resizable=yes",

            // these two will be done dynamically from the buttons clicked, but are
            // needed if you want to use the silent_renew
            response_type: this._responseType,
            scope: this._scope,
            // this will toggle if profile endpoint is used
            loadUserInfo: true,

            // silent renew will get a new access_token via an iframe 
            // just prior to the old access_token expiring (60 seconds prior)
            silent_redirect_uri: window.location.origin + "/silent.html",
            automaticSilentRenew: true,

            // will revoke (reference) access tokens at logout time
            revokeAccessTokenOnSignout: true,

            // this will allow all the OIDC protocol claims to be visible in the window. normally a client app 
            // wouldn't care about them or want them taking up space
            filterProtocolClaims: false
        };



        oidc.Log.logger = window.console;
        oidc.Log.level = oidc.Log.INFO;


        this.UserManager = new oidc.UserManager(config);
    }

    public async Login(): Promise<any> {
        var user = await this.UserManager.getUser()

        if (!user) {
            this.UserManager.signinRedirect({ scope: this._scope, response_type: this._responseType });
        }

        if (user.expired) {
            this.UserManager.signinRedirect({ scope: this._scope, response_type: this._responseType });
        }


        return user;
    }

    public Logout() {
        this.UserManager.signoutRedirect();
    }
}

const EventBus = new Vue()

var fmdCallback = (seq: string) => alert("FMD");

var sk = new shortkey(fmdCallback);

Vue.use(sk);
Vue.use(VueRouter);
Vue.mixin({
    methods: {
        shortcuts() {
            return Object.keys(sk._availableCommands).map(k => sk._availableCommands[k]);
        }
    }
})

const routes = [
    { path: '/', component: require('./components/home/home.vue.html') },
    { name: 'carehome-list', path: '/carehome-list', component: require('./components/carehome/list/carehome-list.scp.html') },

    {
        name: 'carehome-main',
        path: '/carehome-main/:id',
        component: require('./components/carehome/main/carehome-main.scp.html'),
        props: true
    },
    {
        name: 'carehome-dispensation',
        path: '/carehome-dispensation/:carehomeid?',
        component: require('./components/pages/carehome-dispensation/carehome-dispensation.scp.html'),
        //component: require('./components/pages/chart-printing/chartprinting.scp.html'),
        props: true
    },
    {
        name: 'patient-dispensation',
        path: '/patient-dispensation/:patientid?',
        component: require('./components/pages/carehome-dispensation/patient-mar-status.scp.html'),
        //component: require('./components/pages/chart-printing/chartprinting.scp.html'),
        props: true
    },
    {
        name: 'carehome-create',
        path: '/carehome-create',
        component: require('./components/carehome/create/carehome-create.scp.html')
    },
    {
        name: 'patient-create',
        path: '/carehome/:carehomeid/patient/:patientid?',
        component: require('./components/carehome-patients/create/carehome-patient-create.scp.html'),
        props: true
    },
    {
        name: 'carehome-charts',
        path: '/carheome-charts/:carehomeid',
        component: require('./components/pages/chart-printing/chartprinting.scp.html'),
        props: true,
        //query: { carehomeId: 'carehomeid', wardId: 'wardid', patientId :'patientid' }
        //props: (route: any) => ({
        //    carehomeId: route.query.carehomeid,
        //    wardId: route.query.wardid
        //    //,
        //    //wardId: route.query.wardid,
        //    //patientId : route.query.patientid
        //}) 
    },
    //{
    //    name: 'carehome-patient-create',
    //    path: '/carehome-patient-create/:id/:name',
    //    component: require('./components/carehome-patients/create/carehome-patient-create.scp.html')
    //},
    {
        name: 'patient-edit',
        path: '/patient/:patientid',
        component: require('./components/carehome-patients/create/carehome-patient-create.scp.html'),
        props: true
    },
    {
        name: 'patient-main',
        path: '/patient-main/:id/:carehomeid',
        component: require('./components/carehome-patients/detail/carehome-patient-main.scp.html'),
        props: true
    }
    ,
    {
        name: 'patient',
        path: '/patient/:patientid/:carehomeid',
        component: require('./components/pages/patient/patient.scp.html'),
        props: true,
        children: [
            {
                path: 'medprofile',
                name: 'patient.medprofile',
                component: require('./components/appcontrols/PatientMedProfile2/PatientMedProfile2.scp.html'),
                props: true
            },
            {
                path: 'medstock',
                name: 'patient.medstock',
                component: require('./components/appcontrols/PatientMedProfileForm/PatientMedProfileForm.scp.html'),
                props: true
            },
            {
                path: 'orders',
                name: 'patient.orders',
                component: require('./components/appcontrols/PatientReorderForm/PatientReorderForm.scp.html'),
                props: true
            },
            //{
            //    path: 'medprofile',
            //    name: 'patient.medprofile',
            //    component: require('./components/appcontrols/PatientMedProfileForm/PatientMedProfileForm.scp.html'),
            //    props: true
            //},
            {
                path: 'marhistory',
                name: 'patient.marhistory',
                component: require('./components/appcontrols/PatientMarHistory/Patient-Mar-History.scp.html'),
                props: true
            },
            {
                path: 'reports',
                name: 'patient.reports',
                component: require('./components/appcontrols/PatientChartForm/PatientChartForm.scp.html'),
                props: true
            },
            //{
            //    path: 'medstock',
            //    name: 'patient.medstock',
            //    component: require('./components/appcontrols/PatientMedStock/PatientMedStock.scp.html'),
            //    props: true
            //}
        ]
    }
    //{ path: '/datatable', component: require('./components/datatabletest/datatabletest.scp.html') },
    , { path: '/selectize', component: require('./components/selectizetest/selectizetest.scp.html') }
    , { path: '/charts', component: require('./components/pages/chart-printing/chartprinting.scp.html') },
    {
        name: 'charts',
        path: '/charts/:carehomeid/:wardid?/:patientid?',
        component: require('./components/pages/chart-printing/chartprinting.scp.html'),
        props: true,
    },
    {
        name: 'pharmacy-users',
        path: '/pharmacy-users',
        component: require('./components/pages/pharmacy/user-list.scp.html')
    },
    {
        name: 'pharmacy-carehomes',
        path: '/pharmacy-carehomes',
        component: require('./components/pages/pharmacy/carehome-list.scp.html')
    },
    {
        name: 'fmd',
        path: '/fmd',
        redirect: '/fmd/bags',
        component: require('./components/FmdControls/FmdHeader/FmdHeader.scp.html'),
        props: true,
        children: [
            {
                path: 'bags',
                name: 'fmd.bags',
                //component: require('./components/FmdControls/Bag/Bag.scp.html')
                component: require('./components/FmdControls/BulkActions/deliver.scp.html')
            },
            //{
            //    path: 'deliver',
            //    name: 'fmd.deliverbulk',
            //    component: require('./components/FmdControls/BulkActions/deliver.scp.html')
            //},
            {
                path: 'newbag',
                name: 'fmd.newbag',
                component: require('./components/FmdControls/BagManagement/NewBag.scp.html'),
                props: true
            },
            {
                path: 'bag/:bagId?',
                name: 'fmd.managebag',
                component: require('./components/FmdControls/BagManagement/BagManagement.scp.html'),
                props: true
            },
            {
                path: 'calibration',
                name: 'fmd.scannercalibrate',
                component: require('./components/FmdControls/BagManagement/ScannerCalibration.scp.html'),
                props: true
            },
            //{
            //    path: 'dashboard',
            //    name: 'fmd.dashboard',
            //    component: require('./components/FmdControls/Dashboard/Dashboard.scp.html')
            //},
            {
                path: 'delivered',
                name: 'fmd.delivered',
                component: require('./components/FmdControls/Bag/Delivered.scp.html')
            },
            {
                path: 'patients',
                name: 'fmd.patients',
                component: require('./components/FmdControls/Patients/Patients.scp.html')
            },
            {
                path: 'patient/:patientid',
                name: 'fmd.patient',
                component: require('./components/FmdControls/Patients/PatientDetail.scp.html'),
                props: true
            },
            {
                path: 'patient',
                name: 'fmd.newpatient',
                component: require('./components/FmdControls/Patients/NewPatient.scp.html'),
                props: true
            },
            {
                path: 'patient/edit/:patientid',
                name: 'fmd.editpatient',
                component: require('./components/FmdControls/Patients/NewPatient.scp.html'),
                props: true
            },
            //{
            //    path: 'patient/edit/:patientid',
            //    name: 'fmd.patientedit',
            //    component: require('./components/FmdControls/Patients/PatientEdit.scp.html'),
            //    props: true
            //}
        ]
    },
    {
        name: 'pharmacy-carehome-users',
        path: '/pharmacy-carehome-users/:carehomeid',
        props: true,
        component: require('./components/pages/pharmacy/carehome-users.scp.html')
    },
    {
        name: 'manage-pharmacy-user',
        path: '/manage-pharmacy-user/:userid',
        props: true,
        component: require('./components/pages/manage-pharmacy-user/manage-pharmacy-user.scp.html')
    },
    {
        name: 'pharmacy-carehome-user-edit',
        path: '/pharmacy-carehome-user-edit',
        //path: '/pharmacy-carehome-user-edit/:carehomeid/user/:userid',
        component: require('./components/pages/pharmacy/carehome-user-form.scp.html'),
        //props: true
        props: (route: any) => ({ carehomeid: route.query.carehomeid, userid: route.query.userid })
    },
    {
        name: 'users',
        path: '/users',
        component: require('./components/pages/user-list/user-list.scp.html')
    }

];


Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        }
    }
})

new Vue({
    el: '#app-root',
    router: new VueRouter({ mode: 'history', routes: routes }),
    // render: h => h(require('./components/app/app.vue.html')),
    render: h => h(require('./components/AppLoader/AppLoader.scp.html')),
    data: {
        UserId: "",
        UserName: "",
        IsCarehomeUser: false,
        IsLoading: true,
        Carehomes: new Array<CarehomeDto>(),
        Units: new Array<String>(),
        UserManager: {},
        CurrentUnitId: {},
        UiSession: {} 
    },
    mounted: function () {
        var dl = new Dal();
        dl.GetApiServer()
            .then(servers => {
                BaseDal.BaseUri = servers.apiServer;
                FmdBaseDal.BaseUri = servers.apiServer;
                var userManager = new AppUserManager()
                userManager.ConfigureOidc(servers.authServer);

                this.UserManager = userManager;
                var dal = new Dal();
                var that = this;
                var timestamp = moment();

                userManager.Login().then(u => {
                    if (!u) {
                        alert("No User");
                    }
                    BaseDal.Token = u.access_token;
                    FmdBaseDal.Token = u.access_token;
                    this.InitializeUser();
                });
            });
    }
    , methods: {
        InitializeUser() {
            var timestamp = moment();
            var dal = new Dal();
            var that = this;
            dal.GetUser().then(user => {
                this.UserId = user.email;
                this.UserName = user.firstName + " " + user.lastName;
                var promises = [];

                let carehomes = [...new Set(user.userPermissions.map(item => item.carehomeId))];

                for (var carehomeId of carehomes) {
                    if (carehomeId != null) {
                        var promise = dal.GetCarehome(carehomeId).then(ch => {
                            that.Carehomes.push(ch);
                        });
                        promises.push(promise);
                    }
                }

                for (var permission of user.userPermissions) {
                    if (permission.carehomeId != null) {
                        // handled above
                    }
                    else if (permission.unitId != null) {
                        this.CurrentUnitId = permission.unitId;

                        this.UiSession = new UiSession(permission.unitId);
                        that.Units.push(permission.unitId);
                    }
                }



                Promise.all(promises).then(() => {

                    // Moved Carehome portal to different project so this is not relevant
                    //if (this.Carehomes.length > 0) {
                    //    that.IsCarehomeUser = true;
                    //}


                    if (this.$router.currentRoute.path == "\/") {
                        this.$router.push({ name: 'carehome-list' });
                    }

                    var diff = timestamp.diff(moment())
                    if (diff < 1000) {
                        //setTimeout(() => that.IsLoading = false, 1500 - diff);
                        setTimeout(() => that.IsLoading = false, 10);
                    } else {
                        this.IsLoading = false
                    }
                });

            });
        }
    }
});




// WEBPACK FOOTER //
// ./ClientApp/boot.ts